export default __webpack_public_path__ + "static/mi-bg-design-1fe4896a88b00d4a8f0fb187d6d91407.png";